import * as CartActionTypes from '../actionTypes/CartActionTypes';

export const getCartDetails = (payload) => ({
    type: CartActionTypes.CART_DETAILS_GET_REQUEST,
    payload,
});

export default getCartDetails;
